import { inject, type InjectionKey, type Ref } from 'vue'

import type { BrandColorField } from '../lib/brandColorValidation'
import type { OnboardingFormData } from '../lib/onboardingPrefill'

export type OnboardingDataEntryContext = {
  formData: Ref<OnboardingFormData>
  aiCapturedFields: Ref<Set<string>>
  updateField: (field: string, value: string | boolean) => void
  onFieldFocus: (key: string) => void
  fieldClass: (key: string) => string
  isUsOnboarding: Ref<boolean>
  /** Typed brand colors that failed validation and are not stored yet. Null when there is none. */
  brandColorDrafts: Record<BrandColorField, string | null>
}

export const onboardingDataEntryKey: InjectionKey<OnboardingDataEntryContext> =
  Symbol('onboardingDataEntry')

export function useOnboardingDataEntryContext(): OnboardingDataEntryContext {
  const ctx = inject(onboardingDataEntryKey)
  if (!ctx) {
    throw new Error('useOnboardingDataEntryContext() must be used inside OnboardingDataEntry')
  }
  return ctx
}
